import { Skeleton } from 'ui/components/primitives';
import Styles from './Cycle.styles';

export const CycleSkeleton = () => (
  <Styles.Component>
    <Styles.ProgressWrapper>
      <Styles.CycleIcon size="s" />

      <Styles.Progress color="primary" maxValue={1} reverse size="large" value={0} />
    </Styles.ProgressWrapper>
    <Styles.Info>
      <Styles.CycleRectangleLoading>
        <Skeleton radius="sharp" />
      </Styles.CycleRectangleLoading>

      <Styles.CycleRectangleLoading>
        <Skeleton radius="sharp" />
      </Styles.CycleRectangleLoading>
    </Styles.Info>
  </Styles.Component>
);
